var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mom-row-action",class:{ 'mom-row-action--danger': _vm.danger },attrs:{"type":"button","aria-label":_vm.label,"title":_vm.label}},[_c('feather-icon',{attrs:{"icon":_vm.icon,"size":"18"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }